import ULThemeSeparator from "@/components/ULThemeSeparator";
import { extractTokenValue } from "@/utils/helpers/tokenUtils";
import { applyAuth0Theme } from "@/utils/theme/themeEngine";

import AlternativeLogins from "./components/AlternativeLogins";
import SignupForm from "./components/SignupForm";
import { useSignupManager } from "./hooks/useSignupManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function SignupScreen() {
    // Extracting attributes from hook made out of SignupInstance class of Auth0 React ACUL SDK
    const { signup, texts, alternateConnections, locales } = useSignupManager();

    // Check whether separator component needs to be rendered based on social connections
    const showSeparator = alternateConnections && alternateConnections.length > 0;

    // Other Texts
    const separatorText = texts?.separatorText || locales.page.separator;
    // Apply theme from SDK instance when screen loads
    applyAuth0Theme(signup);

    // Extracting Tenant setting for social login component alignment on the layout via theme token
    const socialLoginAlignment = extractTokenValue(
        "--ul-theme-widget-social-buttons-layout"
    );

    const renderSocialLogins = (alignment: "top" | "bottom") => (
        <>
            {alignment === "bottom" && showSeparator && (
                <ULThemeSeparator text={separatorText} />
            )}
            <AlternativeLogins />
            {alignment === "top" && showSeparator && (
                <ULThemeSeparator text={separatorText} />
            )}
        </>
    );

    return (
        // Applying UDS theme overrides using the "theme-universal" class
        <AuthLayout title={texts?.pageTitle || locales.page.title}>

            {socialLoginAlignment === "top" && renderSocialLogins("top")}
            <SignupForm />
            {socialLoginAlignment === "bottom" && renderSocialLogins("bottom")}

        </AuthLayout>
    );
}

export default SignupScreen;
